<script lang="ts">
	import { _ } from '@repo/i18n'
	import { TextWithIcon } from '@repo/ui'
	import { Icon } from '@repo/ui'
	import { Tooltip } from '@repo/ui'
	import { ComputerDesktop, DevicePhoneMobile, DeviceTablet } from '@steeze-ui/heroicons'
	import { UAParser } from 'ua-parser-js'

	interface Props {
		userAgent: string
	}

	let { userAgent }: Props = $props()

	let parser: UAParser = new UAParser(userAgent)
	const result = parser.getResult()

	const deviceIcon =
		result.device.type === 'mobile'
			? DevicePhoneMobile
			: result.device.type === 'tablet'
				? DeviceTablet
				: ComputerDesktop
</script>

<TextWithIcon>
	<Icon small src={deviceIcon} />
	{#if result.browser.name && result.os.name}
		<span>
			{result.browser.name},
			{result.os.name}
		</span>
	{/if}

	<Tooltip>
		{#if result.browser.name || result.os.name || result.device.vendor}
			<table>
				<tbody>
					{#if result.browser.name}
						<tr>
							<th class="pr-2 text-left">
								{$_('userAgent.browser')}
							</th>
							<td>
								{result.browser.name}
								{result.browser.version || ''}
							</td>
						</tr>
					{/if}
					{#if result.os.name}
						<tr>
							<th class="pr-2 text-left">
								{$_('userAgent.os')}
							</th>
							<td>
								{result.os.name}
								{result.os.version || ''}
							</td>
						</tr>
					{/if}
					<tr>
						<th class="pr-2 text-left">
							{$_('userAgent.device')}
						</th>
						<td>
							<TextWithIcon>
								<Icon small src={deviceIcon} />

								{#if result.device.vendor}
									<span>
										{result.device.vendor}
										{result.device.model}
									</span>
								{/if}
							</TextWithIcon>
						</td>
					</tr>
				</tbody>
			</table>
		{:else}
			{userAgent}
		{/if}
	</Tooltip>
</TextWithIcon>
